/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ShareCreateRequestSchemaExpirationDays = typeof ShareCreateRequestSchemaExpirationDays[keyof typeof ShareCreateRequestSchemaExpirationDays];


export const ShareCreateRequestSchemaExpirationDays = {
  NUMBER_30: 30,
  NUMBER_60: 60,
  NUMBER_90: 90,
} as const;
